import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'
import Layout from '../components/Layout'
import Banner from '../components/Banner'
import { defaultTheme } from '../styles'
import TextSection from '../components/TextSection'
import TestimonialsSlider from '../components/TestimonialsSlider'

const AboutPage = () => {

    const data = useStaticQuery(graphql`
    {
      allFile(filter: {absolutePath: {regex: "/images/"}}) {
        nodes {
          name
          id
          childImageSharp {
            gatsbyImageData(
                layout: CONSTRAINED,
                placeholder: BLURRED
            )
            fluid(quality: 100) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `)

  const allImages = data.allFile.nodes; 

    return (
        <Layout>
            <Banner
                eyeBrowCopy="Firm Overview"
                headingCopy="About Craig Charles Law"
            />
            <TextSection
              bgColor={`${defaultTheme.darkBlue}`}
              textColor={`${defaultTheme.white}`}
              modifiers={['hasCols']}
            >
              <div className="cols">
                <div className="imagecol">
                  <Image fluid={allImages.find(node => node.name === "craig-charles-lawyer").childImageSharp.fluid} alt="Craig Charles" />
                </div>
                <div className="textcol">
                  <h2>Craig Charles: Trial Attorney for Victims of Sexual Assault &amp; Catastrophic Injury</h2>
                  <p>
                    Craig Charles is a seasoned trial lawyer whose practice is devoted to representing victims of sexual assault, sexual exploitation, human trafficking, and sexual harassment in the workplace. With more than a decade of litigation and trial experience, Mr. Charles has taken sexual assault cases to verdict and obtained substantial jury awards on behalf of survivors — results that reflect both his courtroom skill and his unwavering commitment to justice.
                  </p>
                  <p>
                    Mr. Charles has recovered multiple millions of dollars for injured and abused victims, including significant trial verdicts in some of the most complex and sensitive cases in this area of the law. His deep experience trying these cases before juries gives him a distinct advantage — he does not simply prepare cases for settlement, he prepares every case for trial.
                  </p>
                  <p>
                    Mr. Charles believes firmly in the boutique law firm model. Unlike high-volume firms where clients and their cases are too often overlooked, Mr. Charles represents only a select number of clients at a time. This approach ensures that every client receives his personal attention and that every case is developed to its fullest potential value.
                  </p>
                  <p>
                    He takes only cases where he believes a profound injustice has occurred — which means he is passionate about every client he represents and fights zealously on their behalf. The result speaks for itself: Mr. Charles consistently achieves multi-million-dollar resolutions, year after year.
                  </p>
                </div>
              </div>
            </TextSection>
            <TextSection>
              <h2>Mr. Charles represents victims of:</h2>
              <h3>Sexual Assault, Exploitation, Trafficking &amp; Harassment</h3>
              <p>
                Mr. Charles's primary focus is representing survivors of sexual assault, sexual exploitation, human trafficking, and sexual harassment in the workplace. He has successfully tried sexual assault cases before juries and obtained large verdicts for his clients. His extensive knowledge of this area of the law — combined with his proven track record at trial — gives him a powerful edge in holding perpetrators and negligent institutions accountable. Beyond the financial recovery, Mr. Charles takes deep pride in the sense of empowerment and closure his clients gain through the legal process.
              </p>
              <h3>Catastrophic Injuries</h3>
              <p>
                Mr. Charles also represents victims who have suffered severe injuries as a result of auto accidents, motorcycle accidents, defective products, construction accidents, trucking accidents, police brutality, and birth injuries. He has years of experience going up against corporations and insurance companies, and he has the resources and tenacity to achieve top-tier results for seriously injured clients.
              </p>
              <p>
                Mr. Charles is a member of the Consumer Advocate Attorneys of Los Angeles, Consumer Attorneys of California, and the American Association for Justice.
              </p>
            </TextSection>
            <TestimonialsSlider bgColor={`${defaultTheme.lightBlue}`} />
        </Layout>
    )
}

export default AboutPage
